export default __webpack_public_path__ + "static/media/twitter-logo.704315c1.svg";